// src/pages/merchant/RewardRules.js — Récompenses du marchand (v1.65.0)
// Réutilise l'écran admin ; le backend limite automatiquement au marchand connecté.
// Maxula
import React from 'react';
import AdminRewardRules from '../admin/AdminRewardRules';

export default function MerchantRewardRules() {
  return <AdminRewardRules />;
}
